let isQf = window.location.hostname.indexOf('aitongqian') !== -1

// 证件类型
const nationalTypeList = [{
    value: '1A',
    label: '身份证',
}, {
    value: '1P',
    label: '港澳台来往内地通行证',
}, {
    value: '1E',
    label: '护照',
}]
// 招聘渠道
const channelList = [{ // 招聘渠道，目前写死，以后可扩展
    value: '1',
    label: '01.校园招聘',
}, {
    value: '2',
    label: '02.校企合作',
}, {
    value: '3',
    label: '03.内部推荐',
}, {
    value: '4',
    label: '04.外部推荐',
}, {
    value: '5',
    label: '05.猎头',
}, {
    value: '6',
    label: '06.RPO',
}, {
    value: '7',
    label: '07.智联招聘',
}, {
    value: '8',
    label: '08.前程无忧',
}, {
    value: '9',
    label: '09.猎聘网',
}, {
    value: '10',
    label: '10.58同城',
}, {
    value: '11',
    label: '11.BOSS直聘',
}, {
    value: '12',
    label: '12.拉勾网',
}, {
    value: '13',
    label: '12.脉脉',
}, {
    value: '14',
    label: '14.大街网',
}, {
    value: '15',
    label: '15.地方性渠道',
}, {
    value: '16',
    label: '16.线下招聘会',
}, {
    value: '17',
    label: '17.其他网络招聘渠道',
}, {
    value: '18',
    label: '18.瓜子官方招聘门户',
}, {
    value: '19',
    label: '19.领英',
}, {
    value: '20',
    label: '20.上传简历',
}, {
    value: '21',
    label: '21.BPO',
}]
// 国籍目前写死
const nationIdList = [{
    value: 'ARG',
    label: '阿根廷',
}, {
    value: 'AUS',
    label: '澳大利亚',
}, {
    value: 'BEL',
    label: '比利时',
}, {
    value: 'BRA',
    label: '巴西',
}, {
    value: 'CAN',
    label: '加拿大',
}, {
    value: 'CHE',
    label: '瑞士',
}, {
    value: 'CHN',
    label: '中国',
}, {
    value: 'DEU',
    label: '德国',
}, {
    value: 'ESP',
    label: '西班牙',
}, {
    value: 'FRA',
    label: '法国',
}, {
    value: 'GAT',
    label: '中国港澳台',
}, {
    value: 'GBR',
    label: '英国',
}, {
    value: 'IND',
    label: '印度',
}, {
    value: 'IRL',
    label: '爱尔兰',
}, {
    value: 'ITA',
    label: '意大利',
}, {
    value: 'JPN',
    label: '日本',
}, {
    value: 'MEX',
    label: '墨西哥',
}, {
    value: 'MYS',
    label: '马来西亚',
}, {
    value: 'NLD',
    label: '荷兰',
}, {
    value: 'SGP',
    label: '新加坡',
}, {
    value: 'THA',
    label: '泰国',
}, {
    value: 'USA',
    label: '美国',
}]
const companyTypeList = [{ // 合同主体（可扩展，目前写死）
    value: 'V01',
    label: '北京外企人力资源服务有限公司宁波分公司',
    flag: '1',
},{ 
    value: 'V02',
    label: '文思海辉技术有限公司',
    flag: '0',
},{
    value: 'V03',
    label: '北京新地世达科技发展有限公司',
    flag: '0',
},{
    value: 'V04',
    label: '软通动力信息技术（集团）有限公司',
    flag: '0',
},{
    value: 'V05',
    label: '上海思芮信息科技有限公司',
    flag: '0',
},{
    value: 'V06',
    label: '中软国际科技服务有限公司',
    flag: '0',
},{
    value: 'V07',
    label: '合肥格诚网络信息技术服务有限公司',
    flag: '0',
},{
    value: 'V08',
    label: '合肥格诚网络信息技术服务有限公司北京分公司',
    flag: '0',
},{
    value: 'V23',
    label: '宁波裕米企业服务有限公司',
    flag: '0',
}]
const emplTypeList = [
//     { // 员工类别 （可扩展，目前写死）
//     value: 'LBF',
//     label: '外包正式工',
// }, {
//     value: 'LBI',
//     label: '外包实习生',
// }, 
{
    value: '11',
    label: '正式员工-外签',
},
{
    value: '12',
    label: isQf ? '外包人员-千峰合泰' : '外包人员-车好多',
},
{
    value: '13',
    label: '外包人员-二手车',
},
{
    value: '14',
    label: '外包人员-新车',
},
{
    value: '15',
    label: '外包人员-车后',
},
{
    value: '16',
    label: isQf ? '外包实习生-千峰合泰' : '外包实习生-车好多',
},
{
    value: '17',
    label: '外包实习生-二手车',
},
{
    value: '18',
    label: '外包实习生-新车',
},
{
    value: '19',
    label: '外包实习生-车后',
},
{
    value: '37',
    label: '正式实习生-外签',
},
]

const statusList = [{
    value: '0',
    label: '创建中'
}, {
    value: '1',
    label: '审批中'
}, {
    value: '2',
    label: '审批未通过'
}, {
    value: '3',
    label: '审批通过',
}, {
    value: '4',
    label: '待入职'
}, {
    value: '5',
    label: '已入职'
}, {
    value: '6',
    label: '已取消'
}, {
    value: '7',
    label: '数据落地中'
}, {
    value: '8',
    label: '数据落地失败'
},{
    value: '9',
    label: '待接收offer '
},{
    value: '10',
    label: '已拒绝offer'
},{
    value: '11',
    label: '待落地'
}]

const maritalStatusList = [{
    value: 'A',
    label: '未婚'
}, {
    value: 'B',
    label: '已婚'
}, {
    value: 'C',
    label: '离异'
}, {
    value: 'D',
    label: '丧偶',
}]

const politicalStatusList = [{
    value: '1A',
    label: '中共党员'
}, {
    value: '1B',
    label: '中共预备党员'
}, {
    value: '1C',
    label: '共青团员'
}, {
    value: '1D',
    label: '群众',
}, {
    value: '1E',
    label: '其他',
}]

const driverLicenseTypeList = [{
    value: '11',
    label: 'A1'
}, {
    value: '12',
    label: 'A2'
}, {
    value: '13',
    label: 'A3'
}, {
    value: '14',
    label: 'B1',
}, {
    value: '15',
    label: 'B2',
}, {
    value: '16',
    label: 'C1',
}, {
    value: '17',
    label: 'C2',
}, {
    value: '18',
    label: 'C3',
}, {
    value: '19',
    label: 'C4',
}, {
    value: '20',
    label: 'D',
}, {
    value: '21',
    label: 'E',
}
// , {
//     value: '22',
//     label: 'F',
// }, {
//     value: '23',
//     label: 'M',
// }
// , {
//     value: '24',
//     label: 'N',
// }
// , {
//     value: '25',
//     label: 'p',
// }
, {
    value: '10',
    label: '无',
}]

const relationWithSelfList = [{
    value: '1C',
    label: '配偶'
}, {
    value: '1D',
    label: '兄弟姐妹'
}, {
    value: '1E',
    label: '朋友'
}, {
    value: '1F',
    label: '同事',
}, {
    value: '1G',
    label: '其他',
}, {
    value: '1H',
    label: '父亲',
}, {
    value: '1I',
    label: '母亲',
}, {
    value: '1J',
    label: '儿子',
}, {
    value: '1K',
    label: '女儿',
}]

const yearBonusMonthNumList = [{
    value: '0',
    label: '0个月'
}, {
    value: '10',
    label: '1个月'
}, {
    value: '20',
    label: '2个月'
}, {
    value: '30',
    label: '3个月',
}]

export const staticList = {
    nationalTypeList,
    channelList,
    nationIdList,
    companyTypeList,
    emplTypeList,
    statusList,
    maritalStatusList,
    driverLicenseTypeList,
    relationWithSelfList,
    politicalStatusList,
    yearBonusMonthNumList
}
